import React from 'react';
import UserListFunctional from './components/user-list-functional';

const UserList = () => {
	return <UserListFunctional />;
};

export default UserList;
